'use strict';

angular.module('amexReconciliationApp')
  .directive('isFutureDate', function () {
    return {
      require: 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        scope.$watch(attrs.ngModel, function (value) {
          ctrl.$setValidity('isFutureDate', !value || value <= new Date());
        });
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/futureDate.js
// module id = 524
// module chunks = 0